export const init = () => {
  const fwk = CUBE.Analytics || {};

  // PAGE VIEW WITH SEARCH
  const search = document.querySelector('#search-button');
  if (search) {
    search.addEventListener('click', () => {
      const inputValue = document.getElementById('search-autocomplete').value;
      const location = window.location.pathname.split('/')[1]
        ? `${window.location.pathname.split('/')[1]}/`
        : '';
      const pageName = `${window.location.origin}/${location}search?Ntt=${inputValue}`;

      CUBE.Analytics.sendPageView(pageName);
    });
  }

  // TRACKER 'SEARCH'
  const tracker = new AnalyticsTracker(
    AnalyticsConstants.trackers.commons.search
  );
  const storage = AnalyticsConstants.ref.pendingSearch;
  const sep = AnalyticsConstants.separator;

  if (
    tc_vars.env_template === 'list' ||
    tc_vars.env_template === 'internal_search'
  )
    localStorage.removeItem(storage);

  // SEARCH - NO RESULT
  const noresultEvent = new AnalyticsConditionalEvent(
    'noresultEvent',
    tracker.defaultEvent()
  );
  noresultEvent.options.action = 'Search-noresult';
  noresultEvent.condition =
    'tc_vars[\'env_template\'] == \'internal_search\' && tc_vars.search_results_number == \'0\'';
  noresultEvent.getLabel = () => tc_vars.search_keyword;
  noresultEvent.postAction(() => {
    localStorage.removeItem(storage);
  });
  tracker.addEvent(noresultEvent);

  // SEARCH - COUNT RESULT
  const resultsCountEvent = new AnalyticsConditionalEvent(
    'resultsCountEvent',
    tracker.defaultEvent()
  );
  resultsCountEvent.options.action = 'Search-result';
  resultsCountEvent.condition =
    'tc_vars[\'env_template\'] == \'internal_search\' && tc_vars.search_results_number != \'0\' && CUBE.Analytics.shoppingtool.get().st != \'internal-search-suggestion\'';
  resultsCountEvent.getLabel = () =>
    tc_vars.search_keyword + sep + tc_vars.search_results_number;
  resultsCountEvent.postAction(() => {
    localStorage.removeItem(storage);
  });
  tracker.addEvent(resultsCountEvent);

  // SEARCH - WITH REDIRECT
  const searchWithRedirection = new AnalyticsConditionalEvent(
    'searchWithRedirection',
    tracker.defaultEvent()
  );
  searchWithRedirection.options.action = 'ManualRedirection';
  searchWithRedirection.condition = '!!tc_vars.from_redirect';
  searchWithRedirection.getLabel = () => {
    const st = fwk.shoppingtool.get();
    let labelDetail = '';
    if (st && st.std) {
      labelDetail = st.std;
      // Update ShoppingTool only for p-product or p-list
      if (tc_vars.env_template === 'product' || tc_vars.env_template === 'list')
        fwk.shoppingtool.set('internal-search-manual-redirection', st.std);
    }
    // eslint-disable-next-line no-restricted-globals
    return `${labelDetail}|${location.pathname}`;
  };
  searchWithRedirection.getValue = () => {
    if (tc_vars.env_template === 'product') {
      return CUBE.Analytics.utils.productpage.getSelectedPrice();
    }
    return 0;
  };
  searchWithRedirection.postAction(() => {
    localStorage.removeItem(storage);
  });
  tracker.addEvent(searchWithRedirection);

  // AUTO REDIRECTION Product
  const productReferenceRedirectionEvent = new AnalyticsConditionalEvent(
    'productReferenceRedirectionEvent',
    tracker.defaultEvent()
  );
  productReferenceRedirectionEvent.options.action =
    'ProductReferenceRedirection';
  productReferenceRedirectionEvent.condition =
    'tc_vars[\'env_template\'] == \'product\' && localStorage.getItem(AnalyticsConstants.ref.pendingSearch) != null && localStorage.getItem(AnalyticsConstants.ref.pendingSearch) != undefined && (CUBE.Analytics.shoppingtool.get().st === \'internal-search-standard\' && CUBE.Analytics.shoppingtool.get().std === tc_vars[\'product_id_model\'])';
  productReferenceRedirectionEvent.getLabel = () => {
    const curSearch = localStorage.getItem(storage);
    const modelId = CUBE.Analytics.utils.productpage.getSelectedModelId();
    return curSearch + sep + modelId;
  };
  productReferenceRedirectionEvent.getValue = () => CUBE.Analytics.utils.productpage.getSelectedPrice();
  // productReferenceRedirectionEvent.postAction(() => {
  //   localStorage.removeItem(storage);
  // });
  productReferenceRedirectionEvent.stopEvent = () =>
    productReferenceRedirectionEvent.getLabel().indexOf('undefined') > -1;
  tracker.addEvent(productReferenceRedirectionEvent);

  // SAVE SEARCH - 'Empty' event : used only to store the keyword in localstorage
  const searchEvent = new AnalyticsTriggerEvent(
    'searchEvent',
    tracker.defaultEvent()
  );
  searchEvent.domElement = window;
  searchEvent.trigger = 'beforeunload';
  searchEvent.stopEvent = () => {
    if (getKeyword() !== '') saveKeyword();
    return true;
  };
  tracker.addEvent(searchEvent);

  // SEARCH - Product
  // const productSearchEvent = new AnalyticsClickEvent(
  //   'productEvent',
  //   tracker.defaultEvent()
  // );
  // productSearchEvent.options.action = 'ProductSearch';
  // productSearchEvent.domContainer = '.l-search-form';
  // productSearchEvent.domElement = '#search-button';
  // productSearchEvent.getLabel = () => getKeyword();
  // productSearchEvent.value = '';
  // productSearchEvent.postAction(() => {
  //   localStorage.removeItem(storage);
  // });
  // tracker.addEvent(productSearchEvent);

  // SEARCH - Product Autocompletion
  // const productAutocompletionEvent = new AnalyticsClickEvent(
  //   'productAutocompletionEvent',
  //   tracker.defaultEvent()
  // );
  // productAutocompletionEvent.options.action = 'AutocompletionProduct';
  // productAutocompletionEvent.domContainer = '.anly-search';
  // productAutocompletionEvent.domElement = '.anly-search-result-products a';
  // productAutocompletionEvent.getLabel = $element => {
  //   const elt = $element.length ? $element[0] : $element;
  //   if (elt && elt.dataset) {
  //     return searchedKeyword + sep + elt.dataset.id;
  //   }
  //   return searchedKeyword;
  // };
  // productAutocompletionEvent.getValue = $element => {
  //   const elt = $element.length ? $element[0] : $element;
  //   if (elt && elt.dataset) {
  //     return elt.dataset.price;
  //   }
  //   return 0;
  // }
  // productAutocompletionEvent.postAction(() => {
  //   localStorage.removeItem(storage);
  // });
  // tracker.addEvent(productAutocompletionEvent);

  // SEARCH - Category Autocompletion
  // const categorieAutocompletionEvent = new AnalyticsClickEvent(
  //   'categorieAutocompletionEvent',
  //   tracker.defaultEvent()
  // );
  // categorieAutocompletionEvent.options.action = 'AutocompletionCategory';
  // categorieAutocompletionEvent.domContainer = '.anly-search';
  // categorieAutocompletionEvent.domElement = '.anly-search-result-pages a';
  // categorieAutocompletionEvent.getLabel = $element =>
  //   searchedKeyword + sep + $element.attr('href');
  // tracker.addEvent(categorieAutocompletionEvent);

  // SEARCH - Search Suggestion : Plus utilisé ET non fonctionnel pour l'instant
  const suggestionEvent = new AnalyticsClickEvent(
    'suggestionEvent',
    tracker.defaultEvent()
  );
  suggestionEvent.options.action = 'Suggestion';
  suggestionEvent.domContainer = '#search-result-top';
  suggestionEvent.domElement = '.categories a';
  suggestionEvent.getLabel = $element => {
    const href = $element.attr('href');
    const didYouMean = href.indexOf('search') > -1 ? `${sep}didyoumean` : '';

    return (
      tc_vars.search_keyword +
      didYouMean +
      sep +
      fwk.utils.getInfoNavFromURL(href, false)
    );
  };
  suggestionEvent.postAction(() => {
    fwk.shoppingtool.set('internal-search-suggestion', tc_vars.search_keyword);
  });
  tracker.addEvent(suggestionEvent);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);

  // UTILS METHODS
  const getKeyword = () => $('#search-autocomplete').val() || '';
  const saveKeyword = () => localStorage.setItem(storage, getKeyword());

  // Save the typed keyword
  let searchedKeyword = '';
  if ($('#search-autocomplete')) {
    $('#search-autocomplete').on('input', evt => {
      searchedKeyword = evt.target.value;
    });
  }
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/commons/search-tracker.js